<template>
    <div>
        <calculator-base-header-sec></calculator-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" @reset="reset" v-on:keyup.enter="testForCalculate">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="form-group form-group-sm">
                                <label for="obligationID">Основица: </label>
                                <input type="number" class="form-control full-width" v-model="scope.obligation1" min="0"
                                    placeholder="0" style="-webkit-appearance: none; margin: 0; -moz-appearance:textfield;">
                                <!-- <input type="text" class="form-control" id="obligationID" ng-model="obligation1" ng-change="changeValue()" ng-required="true"  ng-pattern="/^[0-9]+[\.\,]?[0-9]*$/"/> -->
                            </div>
                        </div>
                    </div>
                    <data-picker-mask-horizontal-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                        @datapiskerDateToValue="emitedDateTo"></data-picker-mask-horizontal-component>


                    <div class="spacer20"></div>

                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm">
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="calculate"
                                :disabled="!validvalue">
                                Израчунај
                            </button>
                            <button type="reset" class="btn btn-base-reset text-uppercase">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>

                    <div class="form-group form-group-sm">
                        <div class="promo-message-register" v-if="help"> Ваш дуг је: {{
                            numeral(scope.kamata).format('0.0,').replace(/ /g, '.') }} динара
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <div class="promo-message-register" v-if="scope.errorShow"> {{ scope.messageError }}</div>
                    </div>

                    <div class="form-group form-group-sm">
                        <table v-if="help" class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th align="center">Период од</th>
                                    <th align="center">Период до</th>
                                    <th align="center">Број дана</th>
                                    <th align="center">Месечна/годишња стопа</th>
                                    <th align="center">Основица</th>
                                    <th align="center">Камата</th>
                                    <th align="center">Укупно</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="p in scope.ind" v-bind:key="p">
                                    <td style="width: 20%" align="center">{{ scope.result.periodOd[p] }}</td>
                                    <td style="width: 20%" align="center">{{ scope.result.periodDo[p] }}</td>
                                    <td style="width: 10%" align="center">{{ scope.result.brojDana[p] }}</td>
                                    <td style="width: 10%" align="center">{{
                                        numeral(scope.result.stopaKam[p]).format('0.0,').replace(/ /g, '.') }}
                                    </td>
                                    <td style="width: 10%" align="center">{{
                                        numeral(scope.result.osnovica[p]).format('0.0,').replace(/ /g, '.') }}
                                    </td>
                                    <td style="width: 20%" align="center">{{
                                        numeral(scope.result.kamataPeriod[p]).format('0.0,').replace(/ /g, '.') }}
                                    </td>
                                    <td style="width: 20%" align="center">{{
                                        numeral(scope.result.ukupno[p]).format('0.0,').replace(/ /g, '.') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import numeral from 'numeral';
import CalculatorBaseHeaderSec from '@/base_pages/calc/CalculatorBaseHeaderSec.vue';
import DataPickerMaskHorizontalComponent from '@/components/DataPickerMaskHorizontalComponent';
// import Datepicker from 'vuejs-datepicker';
import { srCYRL } from 'vuejs-datepicker/dist/locale';


export default {
    name: "InterestCalculator",
    data() {
        return {
            emitedDateFromVal: null,
            emitedDateToVal: null,
            numeral: numeral,

            srCYRL: srCYRL,
            isActOpen: false,
            actHTML: '',
            help: false,
            result: [],
            resultSize: null,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             

            kamatne_stope: [],
            datumi_izmena: [],
            datumi_do: [],

            scope: {
                ind: [],
                dateFrom: null,
                dateTo: null,
                obligation1: null,
            },
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        DataPickerMaskHorizontalComponent,
        CalculatorBaseHeaderSec,
        // Datepicker,
    },
    computed: {
        disabledDatesFrom: function () {
            if (this.scope.dateTo === null) {
                return { from: new Date }
            } else return { from: this.scope.dateTo }
        },
        disabledDatesTo: function () {
            if (this.scope.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.scope.dateFrom, from: new Date }
        },
        validvalue: function () {
            return !isNaN(this.scope.obligation1) && this.scope.obligation1 > 0 && this.scope.dateFrom &&
                this.scope.dateTo;
        }
    },
    methods: {
        emitedDateFrom(e) {
            // this.emitedDateFromVal = e;
            if (e) {
                this.scope.dateFrom = new Date(e);
            } else {
                this.scope.dateFrom = null
            }


        },
        emitedDateTo(e) {
            // this.emitedDateToVal = e;
            if (e) {
                this.scope.dateTo = new Date(e);
            } else {
                this.scope.dateTo = null
            }

        },
        reset() {
            this.scope.result = null;

            this.scope.dateFrom = null;
            this.scope.dateTo = null;
            this.scope.obligation1 = null;

            this.scope.ind = [];
            this.help = false;
            this.$refs.dataPickerMask.resetDate();

            this.maskedDateFrom = null;
            this.$refs.dataPickerMask.maskedDateFrom = "";
            this.$refs.dataPickerMask.maskedDateTo = "";
            console.log("TEST", this.$refs.dataPickerMask.maskedDateFrom);
        },
        fetchData() {
            axios.get(this.baseApiUrl + 'prins/getInterestRateHistory')
                .then(response => {
                    this.scope.all = response.data;
                    for (var m = 0; m < this.scope.all.length; m++) {
                        this.kamatne_stope[m] = this.scope.all[m].value;
                        this.datumi_izmena[m] = new Date(this.scope.all[m].dateFrom);
                        this.datumi_do[m] = new Date(this.scope.all[m].dateTo);
                    }
                });
        },
        testForCalculate() {
            if (this.validvalue) {
                this.calculate();
            }
        },
        calculate() {
            this.scope.obligation = parseFloat(this.convertDecimalNUmber(this.scope.obligation1));
            this.scope.kamata = 0;
            this.help = true;
            this.scope.errorShow = false;
            this.scope.ind = [];
            this.scope.presek = new Date(2012, 11, 25);
            this.scope.presekKonformna = new Date(2001, 2, 3);
            this.scope.ukupno = [];
            this.scope.kamata_period = [];
            this.scope.broj_dana = [];
            this.scope.kam_stope = [];
            this.scope.dat_izmena_od = [];
            this.scope.dat_izmena_do = [];
            this.scope.stopaKam = [];
            this.scope.osnovica = [];
            this.scope.osnovica[0] = this.scope.obligation;


            var i = 0;
            var p = 0;
            var date1_unixtime;
            var date2_unixtime;
            var date3_unixtime;
            var timeDifference;
            var timeDifferenceInHours;
            var timeDifferenceInDays;
            var daysInYear = 0;
            while (this.datumi_izmena[i] < this.scope.dateFrom && i < this.datumi_izmena.length) {
                i++;
            }
            var j = i + 1;
            while (this.datumi_izmena[j] <= this.scope.dateTo && j < this.datumi_izmena.length) {
                j++;
            }
            j--;
            if (((i !== j) || (i === j && this.scope.dateTo >= this.datumi_izmena[j])) && i <= (this.datumi_izmena.length - 1)) {
                console.log('this.scope.dateFrom 1: ', this.scope.dateFrom);
                date1_unixtime = parseInt(this.scope.dateFrom.getTime() / 1000);
                date2_unixtime = parseInt(this.datumi_izmena[i].getTime() / 1000);
                date3_unixtime = 0;
                timeDifference = 0;
                timeDifferenceInHours = 0;
                timeDifferenceInDays = 0;
                daysInYear = 0;
                p = 0;
                if (this.scope.dateFrom.getFullYear() === this.datumi_izmena[i].getFullYear() || (this.scope.dateFrom.getFullYear() % 4 !== 0 && this.datumi_izmena[i].getFullYear() % 4 !== 0) || (this.scope.dateFrom.getFullYear() % 4 === 0 && this.datumi_izmena[i].getFullYear() % 4 === 0) ||
                    ((this.scope.dateFrom.getFullYear() % 100 === 0 && this.datumi_izmena[i].getFullYear() % 100 === 0) && (this.scope.dateFrom.getFullYear() % 4 === 0 && this.datumi_izmena[i].getFullYear() % 4 === 0))) {
                    timeDifference = date2_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    daysInYear = ((this.datumi_izmena[i].getFullYear() % 100 !== 0 && this.datumi_izmena[i].getFullYear() % 4 === 0) || (this.datumi_izmena[i].getFullYear() % 100 === 0 && this.datumi_izmena[i].getFullYear() % 400 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.scope.dateFrom < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[i - 1] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.scope.dateFrom.getMonth() + 1, this.scope.dateFrom.getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.obligation * this.kamatne_stope[i - 1] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }

                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.scope.dateFrom);
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.datumi_do[i - 1]);
                        this.scope.stopaKam[p] = this.kamatne_stope[i - 1];
                        this.scope.ind[p] = p;
                        p++;
                    }
                } else {
                    date3_unixtime = parseInt((new Date(this.scope.dateFrom.getFullYear() + 1, 0, 1)).getTime() / 1000);
                    timeDifference = date3_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    daysInYear = ((this.scope.dateFrom.getFullYear() % 100 !== 0 && this.scope.dateFrom.getFullYear() % 4 === 0) || (this.scope.dateFrom.getFullYear() % 100 === 0 && this.scope.dateFrom.getFullYear() % 400 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.scope.dateFrom < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[i - 1] * timeDifferenceInDays) / this.brojDanaUMesecu(this.scope.dateFrom.getMonth(), this.scope.dateFrom.getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[i - 1] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }
                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_do[p] = this.dateFormat(new Date(this.scope.dateFrom.getFullYear(), 11, 31));
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.scope.dateFrom);
                        this.scope.stopaKam[p] = this.kamatne_stope[i - 1];
                        this.scope.ind[p] = p;
                        p++;
                    }
                    timeDifference = date2_unixtime - date3_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    daysInYear = ((this.datumi_izmena[i].getFullYear() % 100 !== 0 && this.datumi_izmena[i].getFullYear() % 4 === 0) || (this.datumi_izmena[i].getFullYear() % 100 === 0 && this.datumi_izmena[i].getFullYear() % 400 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.scope.dateFrom < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[i - 1] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[i].getMonth() + 1, this.datumi_izmena[i].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[i - 1] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }
                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_od[p] = this.dateFormat((new Date(this.scope.dateFrom.getFullYear() + 1, 0, 1)));
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.datumi_do[i - 1]);
                        this.scope.stopaKam[p] = this.kamatne_stope[i - 1];
                        this.scope.ind[p] = p;
                        p++;
                    }
                }

                for (var k = i; k < j; k++) {
                    date1_unixtime = parseInt(this.datumi_izmena[k].getTime() / 1000);
                    date2_unixtime = parseInt(this.datumi_izmena[k + 1].getTime() / 1000);

                    if (this.datumi_izmena[k].getFullYear() === this.datumi_izmena[k + 1].getFullYear() || (this.datumi_izmena[k].getFullYear() % 4 !== 0 && this.datumi_izmena[k + 1].getFullYear() % 4 !== 0) || (this.datumi_izmena[k].getFullYear() % 4 === 0 && this.datumi_izmena[k + 1].getFullYear() % 4 === 0) || ((this.datumi_izmena[k].getFullYear() % 100 === 0 && this.datumi_izmena[k + 1].getFullYear() % 100 === 0) && (this.datumi_izmena[k].getFullYear() % 4 === 0 && this.datumi_izmena[k + 1].getFullYear() % 4 === 0))) {

                        timeDifference = date2_unixtime - date1_unixtime;
                        timeDifferenceInHours = timeDifference / 60 / 60;
                        timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                        daysInYear = ((this.datumi_izmena[k].getFullYear() % 100 !== 0 && this.datumi_izmena[k].getFullYear() % 4 === 0) || (this.datumi_izmena[k].getFullYear() % 100 === 0 && this.datumi_izmena[k].getFullYear() % 400 === 0)) ? 366 : 365;
                        if (timeDifferenceInDays > 0) {
                            if (this.datumi_izmena[k] < this.scope.presek) {
                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[k].getMonth() + 1, this.datumi_izmena[k].getFullYear());
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            } else {

                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays) / (100 * daysInYear);
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            }
                            if (p > 0)
                                this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                            else
                                this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                            this.scope.broj_dana[p] = timeDifferenceInDays;
                            this.scope.dat_izmena_od[p] = this.dateFormat(this.datumi_izmena[k]);
                            this.scope.dat_izmena_do[p] = this.dateFormat(this.datumi_do[k]);
                            this.scope.stopaKam[p] = this.kamatne_stope[k];
                            this.scope.ind[p] = p;
                            p++;
                        }
                    } else {
                        date3_unixtime = parseInt((new Date(this.datumi_izmena[k].getFullYear() + 1, 0, 1)).getTime() / 1000);
                        timeDifference = date3_unixtime - date1_unixtime;
                        timeDifferenceInHours = timeDifference / 60 / 60;
                        timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                        daysInYear = ((this.datumi_izmena[k].getFullYear() % 100 !== 0 && this.datumi_izmena[k].getFullYear() % 4 === 0) || (this.datumi_izmena[k].getFullYear() % 100 === 0 && this.datumi_izmena[k].getFullYear() % 400 === 0)) ? 366 : 365;
                        if (timeDifferenceInDays > 0) {
                            if (this.datumi_izmena[k] < this.scope.presek) {
                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[k].getMonth() + 1, this.datumi_izmena[k].getFullYear());
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            } else {
                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays) / (100 * daysInYear);
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            }

                            this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                            this.scope.broj_dana[p] = timeDifferenceInDays;
                            this.scope.dat_izmena_od[p] = this.dateFormat(this.datumi_izmena[k]);
                            this.scope.dat_izmena_do[p] = this.dateFormat(new Date(this.datumi_izmena[k].getFullYear(), 11, 31));
                            this.scope.stopaKam[p] = this.kamatne_stope[k];
                            this.scope.ind[p] = p;
                            p++;
                        }
                        timeDifference = date2_unixtime - date3_unixtime;
                        timeDifferenceInHours = timeDifference / 60 / 60;
                        timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                        daysInYear = ((this.datumi_izmena[k + 1].getFullYear() % 100 !== 0 && this.datumi_izmena[k + 1].getFullYear() % 4 === 0) || ((this.datumi_izmena[k + 1].getFullYear() % 100 === 0 && this.datumi_izmena[k + 1].getFullYear() % 400 === 0))) ? 366 : 365;
                        if (timeDifferenceInDays > 0) {
                            if (this.datumi_izmena[k] < this.scope.presek) {
                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[k].getMonth() + 1, this.datumi_izmena[k].getFullYear());
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            } else {
                                this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[k] * timeDifferenceInDays) / (100 * daysInYear);
                                this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                            }
                            this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                            this.scope.broj_dana[p] = timeDifferenceInDays;
                            this.scope.dat_izmena_od[p] = this.dateFormat(new Date(this.datumi_izmena[k].getFullYear() + 1, 0, 1));
                            this.scope.dat_izmena_do[p] = this.dateFormat(this.datumi_do[k]);
                            this.scope.stopaKam[p] = this.kamatne_stope[k];
                            this.scope.ind[p] = p;
                            p++;
                        }
                    }
                }

                date1_unixtime = parseInt(this.datumi_izmena[j].getTime() / 1000);
                date2_unixtime = parseInt(this.scope.dateTo.getTime() / 1000);

                if (this.datumi_izmena[j].getFullYear() === this.scope.dateTo.getFullYear() || (this.scope.dateTo.getFullYear() % 4 !== 0 && this.datumi_izmena[j].getFullYear() % 4 !== 0) || (this.scope.dateTo.getFullYear() % 4 === 0 && this.datumi_izmena[j].getFullYear() % 4 === 0) || ((this.scope.dateTo.getFullYear() % 100 === 0 && this.datumi_izmena[j].getFullYear() % 100 === 0) && (this.scope.dateTo.getFullYear() % 4 === 0 && this.datumi_izmena[j].getFullYear() % 4 === 0))) {
                    timeDifference = date2_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24) + 1;
                    daysInYear = ((this.datumi_izmena[j].getFullYear() % 100 !== 0 && this.datumi_izmena[j].getFullYear() % 4 === 0) || (this.datumi_izmena[j].getFullYear() % 100 === 0 && this.datumi_izmena[j].getFullYear() % 4 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }
                        if (p > 0)
                            this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                        else
                            this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.datumi_izmena[j]);
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.scope.dateTo);
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        this.scope.ind[p] = p;
                        p++;
                    }
                } else {
                    date3_unixtime = parseInt((new Date(this.datumi_izmena[j].getFullYear() + 1, 0, 1)).getTime() / 1000);
                    timeDifference = date3_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    daysInYear = ((this.datumi_izmena[j].getFullYear() % 100 !== 0 && this.datumi_izmena[j].getFullYear() % 4 === 0) || (this.datumi_izmena[j].getFullYear() % 100 === 0 || this.datumi_izmena[j].getFullYear() % 4 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }

                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.datumi_izmena[j]);
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        //Energosoft izmena za kalkulator
                        //this.scope.dat_izmena_do[p] = new Date(this.datumi_izmena[j].getFullYear(), 11, 31);
                        this.scope.dat_izmena_do[p] = this.dateFormat(new Date(this.datumi_izmena[j].getFullYear(), 11, 31));
                        //
                        this.scope.ind[p] = p;
                        p++;
                    }
                    timeDifference = date2_unixtime - date3_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24) + 1;
                    daysInYear = ((this.scope.dateTo.getFullYear() % 100 !== 0 && this.scope.dateTo.getFullYear() % 4 === 0) || (this.scope.dateTo.getFullYear() % 100 === 0 && this.scope.dateTo.getFullYear() % 4 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }

                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        this.scope.dat_izmena_od[p] = this.dateFormat(new Date(this.datumi_izmena[j].getFullYear() + 1, 0, 1));
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.scope.dateTo);
                        this.scope.ind[p] = p;
                        p++;
                    }
                }
                this.scope.kamata = this.scope.kamata + this.scope.obligation;

            } else {
                //oba datuma posle poslednje izmene ili izmedju dve
                j = j - 1;
                console.log('this.scope.dateFrom 2: ', this.scope.dateFrom);
                date1_unixtime = parseInt(this.scope.dateFrom.getTime() / 1000);
                date2_unixtime = parseInt(this.scope.dateTo.getTime() / 1000);
                date3_unixtime = 0;
                timeDifference = 0;
                timeDifferenceInHours = 0;
                timeDifferenceInDays = 0;
                daysInYear = 0;
                if (this.scope.dateFrom.getFullYear() === this.scope.dateTo.getFullYear() || (this.scope.dateFrom.getFullYear() % 4 !== 0 && this.scope.dateTo.getFullYear() % 4 !== 0) || (this.scope.dateFrom.getFullYear() % 4 === 0 && this.scope.dateTo.getFullYear() % 4 === 0)) {
                    timeDifference = date2_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    timeDifferenceInDays = timeDifferenceInDays + 1;
                    daysInYear = ((this.scope.dateTo.getFullYear() % 100 !== 0 && this.scope.dateTo.getFullYear() % 4 === 0) || (this.scope.dateTo.getFullYear() % 100 === 0 && this.scope.dateTo.getFullYear() % 400 === 0)) ? 366 : 365;

                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }
                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.scope.dateFrom);
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.scope.dateTo);
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        this.scope.ind[p] = p;
                        p++;
                    }
                } else {
                    date3_unixtime = parseInt((new Date(this.scope.dateFrom.getFullYear() + 1, 0, 1)).getTime() / 1000);
                    timeDifference = date3_unixtime - date1_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    daysInYear = ((this.scope.dateFrom.getFullYear() % 100 !== 0 || this.scope.dateFrom.getFullYear() % 4 === 0) || (this.scope.dateTo.getFullYear() % 100 === 0 && this.scope.dateTo.getFullYear() % 400 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }

                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.osnovica[p]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        this.dateFormat(this.scope.dateTo);
                        //Energosoft izmena kalkulatora
                        //this.scope.dat_izmena_do[p] = this.dateFormat(this.scope.dateTo);
                        this.scope.dat_izmena_do[p] = this.dateFormat(new Date(this.scope.dateFrom.getFullYear(), 11, 31));
                        //
                        this.scope.dat_izmena_od[p] = this.dateFormat(this.scope.dateFrom);
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        this.scope.ind[p] = p;
                        p++;
                    }
                    timeDifference = date2_unixtime - date3_unixtime;
                    timeDifferenceInHours = timeDifference / 60 / 60;
                    timeDifferenceInDays = Math.round(timeDifferenceInHours / 24);
                    timeDifferenceInDays = timeDifferenceInDays + 1;
                    daysInYear = ((this.scope.dateTo.getFullYear() % 100 === 0 && this.scope.dateTo.getFullYear() % 400 === 0) || (this.scope.dateTo.getFullYear() % 100 !== 0 && this.scope.dateTo.getFullYear() % 4 === 0)) ? 366 : 365;
                    if (timeDifferenceInDays > 0) {
                        if (this.datumi_izmena[j - 1] < this.scope.presek) {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays / 100) / this.brojDanaUMesecu(this.datumi_izmena[j].getMonth() + 1, this.datumi_izmena[j].getFullYear());
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        } else {
                            this.scope.kamata_period[p] = (this.scope.osnovica[p] * this.kamatne_stope[j] * timeDifferenceInDays) / (100 * daysInYear);
                            this.scope.osnovica[p + 1] = this.scope.osnovica[p];
                        }

                        this.scope.ukupno[p] = Math.round((this.scope.kamata_period[p] + this.scope.ukupno[p - 1]) * 100) / 100;
                        this.scope.broj_dana[p] = timeDifferenceInDays;
                        //Energosoft izmena za kalk
                        //this.scope.dat_izmena_od[p] = this.dateFormat((new Date(this.scope.dateFrom.getFullYear(), 11, 31)));
                        this.scope.dat_izmena_od[p] = this.dateFormat((new Date(this.scope.dateFrom.getFullYear() + 1, 0, 1)));
                        //
                        this.scope.dat_izmena_do[p] = this.dateFormat(this.scope.dateTo);
                        this.scope.stopaKam[p] = this.kamatne_stope[j];
                        this.scope.ind[p] = p;
                        p++;
                    }
                }
            }
            this.scope.kamata = this.scope.ukupno[p - 1];
            this.scope.result = {
                ukupno: this.scope.ukupno,
                stopaKam: this.scope.stopaKam,
                periodOd: this.scope.dat_izmena_od,
                periodDo: this.scope.dat_izmena_do,
                brojDana: this.scope.broj_dana,
                kamataPeriod: this.scope.kamata_period,
                osnovica: this.scope.osnovica
            };

            console.log(this.scope.result);
            console.log(this.scope.ind);
        },
        convertDecimalNUmber(num) {
            if (num.indexOf(",") > -1)
                return num.replace(",", ".");
            else return num;
        },
        brojDanaUMesecu(month, year) {
            return new Date(year, month, 0).getDate();
        },
        dateFormat(today) {
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            return dd + '.' + mm + '.' + yyyy;
        }
    },
    created() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>
